import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { node, aliasNode, nodeWithArgs, toQuery, toMutation, enumeration } from 'common/util/queryHelper';
import { isEmpty, set, get, find, map } from 'lodash';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
export const ACTIONS = {
    PART11_LOAD_USERS: 'PART11_LOAD_USERS',
    PART11_RESET_PASSWORD: 'PART11_RESET_PASSWORD',
    PART11_LOAD_USER_BINDERS: 'PART11_LOAD_USER_BINDERS',
    PART11_LOAD_USER_STUDIES: 'PART11_LOAD_USER_STUDIES',
    PART11_LOAD_ALL_USER_BINDERS: 'PART11_LOAD_ALL_USER_BINDERS',
    PART11_RESET_TRAINING: 'PART11_RESET_TRAINING',
    PART11_CREATE_USER_REQUEST: 'PART11_CREATE_USER_REQUEST',
    PART11_CREATE_USER_SUCCESS: 'PART11_CREATE_USER_SUCCESS',
    PART11_CREATE_USER_FAILURE: 'PART11_CREATE_USER_FAILURE',
    PART11_RESET_USER_PASSWORD: 'PART11_RESET_USER_PASSWORD',
    PART11_SET_USER_ACTIVE: 'PART11_SET_USER_ACTIVE',
    PART11_RESET_USER_FORM_FLAGS: 'PART11_RESET_USER_FORM_FLAGS',
    PART11_CLEAR_USERS_SCENE: 'PART11_CLEAR_USERS_SCENE',
    PART11_RESET_USER_BINDERS: 'PART11_RESET_USER_BINDERS',
    PART11_RESET_USER_STUDIES: 'PART11_RESET_USER_STUDIES',
    PART11_SET_PROCESS_STATES: 'PART11_SET_PROCESS_STATES',
    PART11_RESEND_REGISTRATION_EMAIL: 'PART11_RESEND_REGISTRATION_EMAIL',
    PART11_LOAD_LOGIN_METHODS: 'PART11_LOAD_LOGIN_METHODS',
    PART11_LOADING_USERS: 'PART11_LOADING_USERS',
    PART11_LOADING_USER_BINDERS: 'PART11_LOADING_USER_BINDERS',
    PART11_LOADING_USER_STUDIES: 'PART11_LOADING_USER_STUDIES',
    PART11_LOADED_USERS: 'PART11_LOADED_USERS',
    PART11_LOADED_USER_BINDERS: 'PART11_LOADED_USER_BINDERS',
    PART11_LOADED_USER_STUDIES: 'PART11_LOADED_USER_STUDIES',
    PART11_TOTAL_USERS: 'PART11_TOTAL_USERS',
    PART11_TOTAL_ACTIVE_TASKS: 'PART11_TOTAL_ACTIVE_TASKS',
    PART11_REMOVE_USER_FROM_BINDER: 'PART11_REMOVE_USER_FROM_BINDER',
    PART11_REMOVE_USER_FROM_STUDY_BINDER: 'PART11_REMOVE_USER_FROM_STUDY_BINDER',
    PART11_LOADING_ALL_USER_BINDERS: 'PART11_LOADING_ALL_USER_BINDERS',
    PART11_LOADED_ALL_USER_BINDERS: 'PART11_LOADED_ALL_USER_BINDERS',
    PART11_RESET_ALL_USER_BINDERS: 'PART11_RESET_ALL_USER_BINDERS',
};

export const DEFAULT_LIMIT = 50;
export const INITIAL_OFFSET = 0;

export const filterOptions = [
    { displayName: 'Active', gqlName: 'ACTIVE' },
    { displayName: 'Inactive', gqlName: 'INACTIVE' }
];

export const sortOptions = [
    { displayName: 'Last Name', gqlName: 'last_name' },
    { displayName: 'Creation Date', gqlName: 'createdAt' },
    { displayName: 'Email Address', gqlName: 'email_address' }
];

export const sortOrderOptions = [
    { displayName: 'Ascending', gqlName: 'ASC' },
    { displayName: 'Descending', gqlName: 'DESC' }
];

const userShape = (institutionId, status) => {
    return [
        'id',
        'firstName',
        'lastName',
        'displayName',
        'emailAddress',
        'sub',
        'createdAt',
        'isActive',
        'passwordChanged',
        'needsPasswordChanged',
        'lockedOut',
        'loginMethodId',
        'isSso',
        'ssoAttribute',
        'lastLogin',
        nodeWithArgs('groups', {
            institutionId,
        }, [
            'id',
            'displayName',
            'description',
            'priority'
        ]),
        node('registrationSteps', [
            node('task', [
                'createdAt'
            ]),
            node('steps', [
                'stepStatus',
                'updatedAt',
                node('state', [
                    'name',
                    'displayName',
                    'type'
                ])
            ])
        ])
    ];
};

export function loadUsers(institutionId, userId, searchParams, isGroupUser = false, status = 'active') {
    return (dispatch, getState) => {
        dispatch(loadingUsers());
        const processStatesNode = nodeWithArgs('processStates', {
            processType: 'registration'
        }, [
            'id',
            'name',
            'displayName'
        ]);

        return queryGraphQL(toQuery(processStatesNode)).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', map(response.errors, 'message')));
                return false;
            }
            dispatch({
                type: ACTIONS.PART11_SET_PROCESS_STATES,
                payload: response.data.processStates
            });
            return true;
        }).then(successful => {
            if (!successful) {
                dispatch(loadedUsers());
                return;
            }
            searchParams = isEmpty(searchParams) ? null : searchParams;
            const queryText = get(searchParams, 'q', null);
            let filterField;
            if (get(searchParams, 'filter', null) !== null && (!isGroupUser)) {
                filterField = enumeration(get(searchParams, 'filter') === 'ACTIVE' ? 'true' : 'false');
            }
            const filterField2 = get(searchParams, 'filter2', null);
            const sortField = get(searchParams, 'sort', null);
            const sortOrder = get(searchParams, 'order', null);
            const searchLimit = parseInt(get(searchParams, 'limit'));
            const limit = isGroupUser ? null : (searchLimit || DEFAULT_LIMIT);
            const searchOffset = parseInt(get(searchParams, 'offset'));
            const offset = searchOffset ? searchOffset : INITIAL_OFFSET;

            let processState = null;
            if (filterField2) {
                const storeState = getState();
                const processStates = get(storeState, 'process.processStates', null);
                const processStateByName = find(processStates, ['name', filterField2]);
                processState = get(processStateByName, 'id', null);
            }

            let shape = userShape(institutionId, status);
            // Get a list of binders only for one specific user
            if (userId) {
                shape.push(nodeWithArgs('binders', {
                    institutionId,
                    status,
                }, [
                    'title',
                    'primaryInvestigator',
                    'departmentSiteDg',
                    'studyId',
                ]));
            }
            const usersNode = nodeWithArgs('users', {
                id: userId,
                institutionId,
                queryText,
                filterField,
                sortField,
                sortOrder,
                processState,
                offset,
                limit,
            }, shape);

            const usersCountNode = nodeWithArgs('countUsers', {
                id: userId,
                institutionId,
                queryText,
                filterField,
                sortField,
                sortOrder,
                processState,
            });

            const queries = userId ? [usersNode] : [usersNode, usersCountNode];
            return queryGraphQL(toQuery(queries)).then(response => {
                if (response.errors) {
                    dispatch(addApplicationMessages('error', map(response.errors, 'message')));
                    dispatch(loadedUsers());
                    return;
                }
                const userCount = userId ? 1 : response.data.countUsers;
                const reset = get(searchParams, 'reset', false);
                dispatch({
                    type: ACTIONS.PART11_LOAD_USERS,
                    payload: {
                        users: response.data.users,
                        userCount,
                        institutionId,
                        reset,
                    }
                });
            });
        });
    };
}

export function loadUserBinders(institutionId, userId) {
    return async dispatch => {
        dispatch(loadingUserBinders());
        const userBindersNode = nodeWithArgs('getUserBinders', {
            userId,
            institutionId,
        }, [
            'id',
            'name',
            'principalInvestigator',
            'site'
        ]);
        const response = await queryGraphQL(toQuery(userBindersNode));
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch(loadedUserBinders());
            return;
        }
        dispatch({
            type: ACTIONS.PART11_LOAD_USER_BINDERS,
            payload: {
                data: get(response, 'data.getUserBinders', []),
            }
        });
    };
}

export function loadUserStudies(institutionId, userId) {
    return async dispatch => {
        dispatch(loadingUserStudies());
        const userStudiesNode = nodeWithArgs('getUserStudies', {
            userId,
            institutionId,
        }, [
            'id',
            'name',
            'principalInvestigator',
            'site'
        ]);
        const response = await queryGraphQL(toQuery(userStudiesNode));
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch(loadedUserStudies());
            return;
        }
        dispatch({
            type: ACTIONS.PART11_LOAD_USER_STUDIES,
            payload: {
                data: get(response, 'data.getUserStudies', []),
            }
        });
    };
}

export function loadAllUserBinders(institutionId, userId) {
    return async dispatch => {
        dispatch({ type: ACTIONS.PART11_LOADING_ALL_USER_BINDERS });
        const allUserBindersNode = nodeWithArgs('getAllUserBinders', {
            userId,
            institutionId,
        }, [
            'id',
            'name',
            'principalInvestigator',
            'site',
            'studyId',
            'studyUserType'
        ]);
        const response = await queryGraphQL(toQuery(allUserBindersNode));
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch({ type: ACTIONS.PART11_LOADED_ALL_USER_BINDERS });
            return;
        }
        dispatch({
            type: ACTIONS.PART11_LOAD_ALL_USER_BINDERS,
            payload: {
                data: get(response, 'data.getAllUserBinders', []),
            }
        });
    };
}

export function resetAllUserBinders() {
    return { type: ACTIONS.PART11_RESET_ALL_USER_BINDERS };
}

export const removeUserFromStudyBinder = (binderId, user, institutionId) => {
    return async dispatch => {
        try {
            const userId = user.id;
            const removeUser = nodeWithArgs('removeUserFromStudyBinder', {
                institutionId,
                binderId,
                userId
            }, [
                'userId',
                'binderId',
                'removed',
                'undoId'
            ]);
            const response = await queryGraphQL(toMutation(removeUser));

            if (response.errors) {
                return dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            }
            return dispatch({
                type: ACTIONS.PART11_REMOVE_USER_FROM_STUDY_BINDER,
                payload: response.data.removeUserFromStudyBinder,
            });
        } catch (error) {
            dispatch(addApplicationMessages('error', [error.responseText]));
        }
    };
};

export function getTotalUsers(institutionId) {
    return (dispatch, getState) => {
        const usersCountNode = nodeWithArgs('countUsers', { institutionId });
        return queryGraphQL(toQuery(usersCountNode)).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', map(response.errors, 'message')));
                return;
            }

            dispatch({
                type: ACTIONS.PART11_TOTAL_USERS,
                payload: {
                    count: response.data.countUsers,
                }
            });
        });
    };
}

export async function getTotalUsersDelegations(institutionId, userId) {
    if (!institutionId || !userId) return;
    try {
        const query = nodeWithArgs('getUserDelegationCount', {
            userId,
            institutionId,
        }, [
            'count'
        ],);
        const { data: { getUserDelegationCount } } = await (await queryGraphQL(toQuery(query)));
        return getUserDelegationCount;
    } catch (error) {
        return 0;
    }
}

export function clearUsersScene() {
    return { type: ACTIONS.PART11_CLEAR_USERS_SCENE };
}

export function loadingUsers() {
    return { type: ACTIONS.PART11_LOADING_USERS };
}

export function loadingUserBinders() {
    return { type: ACTIONS.PART11_LOADING_USER_BINDERS };
}

export function loadingUserStudies() {
    return { type: ACTIONS.PART11_LOADING_USER_STUDIES };
}

export function loadedUsers() {
    return { type: ACTIONS.PART11_LOADED_USERS };
}

export function loadedUserBinders() {
    return { type: ACTIONS.PART11_LOADED_USER_BINDERS };
}

export function loadedUserStudies() {
    return { type: ACTIONS.PART11_LOADED_USER_STUDIES };
}

export function resetUserFormFlags() {
    return {
        type: ACTIONS.PART11_RESET_USER_FORM_FLAGS,
        payload: {
            shouldRedirect: false,
            isLoading: false,
            error: { isPresent: false, message: null }
        }
    };
}

export function resetUserBinders() {
    return { type: ACTIONS.PART11_RESET_USER_BINDERS };
}

export function resetUserStudies() {
    return { type: ACTIONS.PART11_RESET_USER_STUDIES };
}

export function createUserRequest(institutionId, user) {
    return {
        type: ACTIONS.PART11_CREATE_USER_REQUEST,
        payload: {
            institutionId,
            user,
        }
    };
}

export function createUserSuccess(responseData) {
    return {
        type: ACTIONS.PART11_CREATE_USER_SUCCESS,
        payload: {
            user: responseData,
        }
    };
}

export function createUserFailure(error) {
    return {
        type: ACTIONS.PART11_CREATE_USER_FAILURE,
        payload: {
            error: error
        }
    };
}

export function submitCreateUser(institutionId, user) {
    const mutation = toMutation(nodeWithArgs('createUser', {
        user: {
            ...user,
            institutionId,
        }
    }, [
        'id',
        'firstName',
        'lastName',
        'displayName',
        'emailAddress',
        'sub',
    ]));

    return dispatch => {
        dispatch(createUserRequest(institutionId, user));
        return mutateGraphQL(mutation).then(res => {
            if (!res.formattedErrors && res.data != null) {
                return dispatch(createUserSuccess(res.data.createUser));
            } else {
                return dispatch(createUserFailure(res.formattedErrors));
            }
        });
    };
}

export function submitUpdateUser(institutionId, user) {

    set(user, 'institutionId', institutionId);

    const mutation = toMutation(nodeWithArgs('updateUser', {
        user: {
            ...user,
        }
    }, [
        'id', 'firstName', 'lastName', 'displayName', 'emailAddress', 'sub'
    ]));

    return dispatch => {
        dispatch(createUserRequest(institutionId, user));
        return mutateGraphQL(mutation).then(res => {
            if (!res.formattedErrors && res.data != null) {
                return dispatch(createUserSuccess(res.data.updateUser));
            } else {
                return dispatch(createUserFailure(res.formattedErrors));
            }
        });
    };
}

export function resetUserPassword(user) {
    const query = toMutation(nodeWithArgs('resetUserPassword', {
        sub: user.sub
    }, [
        'id'
    ]));

    return dispatch => {
        return queryGraphQL(query).then(results => {
            if (results.errors) {
                dispatch(addApplicationMessages('error', map(results.errors, 'message')));
            } else {
                dispatch({
                    type: ACTIONS.PART11_RESET_USER_PASSWORD,
                    payload: {
                        userId: results.data.resetUserPassword
                    }
                });
                dispatch(addApplicationMessages('success', ['The user has been sent an email to reset their password.']));
            }
        });
    };
}

export function setUserActive(user, institutionId) {
    const query = toMutation(nodeWithArgs('setUserActive', {
        sub: user.sub,
        isActive: !user.isActive,
        institutionId,
        isNewDoaFlow: false
    }, [
        'sub', 'isActive'
    ]));

    return dispatch => {
        return queryGraphQL(query).then(results => {
            dispatch({
                type: ACTIONS.PART11_SET_USER_ACTIVE,
                payload: {
                    userId: user.id,
                    isActive: results.data.setUserActive.isActive,
                }
            });
        });
    };
}

export function setUserActiveV2(user, institutionId, endDelegations = true) {
    const query = toMutation(nodeWithArgs('setUserActive', {
        sub: user.sub,
        isActive: !user.isActive,
        institutionId,
        isNewDoaFlow: true,
        updateExpiredDelegations: endDelegations
    }, [
        'sub', 'isActive'
    ]));

    return dispatch => {
        return queryGraphQL(query).then(results => {
            if(user.isActive && endDelegations) {
                dispatch(addApplicationMessages('success', [`${user.displayName} has been deactivated.`]));
            } else if(!endDelegations) {
                dispatch(addApplicationMessages('success', [`${user.displayName} has been deactivated. To remain compliant, please update any delegation logs associated with this user.`]));
            }
            
            dispatch({
                type: ACTIONS.PART11_SET_USER_ACTIVE,
                payload: {
                    userId: user.id,
                    isActive: results.data.setUserActive.isActive,
                }
            });
        });
    };
}

export function resendRegistrationEmail(user) {
    const query = toMutation(nodeWithArgs('resetUser', {
        id: user.id,
    }));

    return dispatch => {
        return queryGraphQL(query).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            } else {
                dispatch(addApplicationMessages('success', ['The user has been sent a new registration email.']));
            }
        });
    };
}

export function loadLoginMethods(institutionId) {
    let query;

    query = toQuery(aliasNode('loginMethods', 'loadLoginMethods', [
        'id',
        'name',
        'type',
        node('config', ['isSamlAttributeEmail', 'samlAttributeDisplayName', 'userAttribute', 'providerType']),
    ]));


    return dispatch => queryGraphQL(query).then(response => {
        if (response.errors) {
            return dispatch(addApplicationMessages('error', map(response.errors, 'message')));
        }
        else {
            return dispatch({
                type: ACTIONS.PART11_LOAD_LOGIN_METHODS,
                payload: response.data.loginMethods,
            });
        }
    });
}

export const changeUserActive = (user, institutionId) => {
    const { id: userId, sub: userSub, isActive } = user;
    if (!isActive) {
        return setUserActive(user, institutionId);
    }

    return async dispatch => {
        try {
            const nodeQuery = nodeWithArgs('countTasksAndSignatureRequests', { userId, userSub });
            const response = await queryGraphQL(toQuery(nodeQuery));
            const totalActiveTasks = get(response, 'data.countTasksAndSignatureRequests', 0);

            if (totalActiveTasks > 0) {
                dispatch({
                    type: ACTIONS.PART11_TOTAL_ACTIVE_TASKS,
                    payload: { userId, totalActiveTasks },
                });
            }

            return dispatch(setUserActive(user, institutionId));
        } catch (error) {
            dispatch(addApplicationMessages('error', [error.responseText]));
        }
    };
};

export const getUsersTaskCount = (user) => {
    const { id: userId, sub: userSub } = user;
    return async dispatch => {
        try {
            const nodeQuery = nodeWithArgs('countTasksAndSignatureRequests', { userId, userSub });
            const response = await queryGraphQL(toQuery(nodeQuery));
            const totalActiveTasks = get(response, 'data.countTasksAndSignatureRequests', 0);

            
            if (totalActiveTasks > 0) {
                dispatch({
                    type: ACTIONS.PART11_TOTAL_ACTIVE_TASKS,
                    payload: { userId, totalActiveTasks },
                });
            }
            return totalActiveTasks;
        } catch (error) {
            dispatch(addApplicationMessages('error', [error.responseText]));
        }
    };
};

export const removeUserFromBinder = (binderId, user, institutionId) => {
    return async dispatch => {
        try {
            const userId = user.id;
            const removeUser = nodeWithArgs('removeUserFromBinder', {
                institutionId,
                binderId,
                userId
            }, [
                'userId',
                'binderId',
                'removed',
                'undoId'
            ]);
            const response = await queryGraphQL(toMutation(removeUser));

            if (response.errors) {
                return dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            }
            else {
                return dispatch({
                    type: ACTIONS.PART11_REMOVE_USER_FROM_BINDER,
                    payload: response.data.removeUserFromBinder,
                });
            }

        } catch (error) {
            dispatch(addApplicationMessages('error', [error.responseText]));
        }
    };
};
